export default __webpack_public_path__ + "static/media/login-bg.61826bd2.jpg";